import {TipoOrdenesBalanzaService} from './../../services/tipo-ordenes-balanza.service';
import {LfsaBotonEditarGridComponent} from './../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UtilsService} from './../../../../shared/utils/utils.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';

@Component({
  selector: 'app-tipos-ordenes-balanza',
  templateUrl: './tipos-ordenes-balanza.component.html',
  styleUrls: ['./tipos-ordenes-balanza.component.css'],
})
export class TiposOrdenesBalanzaComponent implements OnInit {
  public loading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.tipoOrdenesBalanza;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public tituloModal: string;
  public isCreate: boolean = true;
  public garita: any;
  public cmbUsuarios: any[] = [];
  public cmbBascula: any[] = [];

  public agregarForm = new FormGroup({
    id: new FormControl(0),
    desca: new FormControl(null, [Validators.required, Validators.maxLength(50),]),
    tipOrden: new FormControl(null, Validators.required),
    granel: new FormControl(null, Validators.required),
    tipoTolerancia: new FormControl(null, Validators.required),
    tolerancia: new FormControl(null, [Validators.required,]),
    ingresa: new FormControl(false, []),
    ingreso_calidad: new FormControl(false, []),
    gradoApi: new FormControl(false, []),
    generaOcAuto: new FormControl(false),
    premiCastigo: new FormControl(false, []),
    oriFlete: new FormControl(false, []),
    paramCalidad: new FormControl(false, []),
    inspec: new FormControl(false, []),
    reqOrden: new FormControl(false, []),
    clasePerdido: new FormControl('', [Validators.maxLength(4)]),
    orgCompra: new FormControl('', []),
    grupoCompra: new FormControl('', []),
    prePesaje: new FormControl(false, []),
    reCaptura: new FormControl(false, [Validators.required]),
  });
  
  errorBothOrderCheck = false;
  errorLoteInspeccionCheck = false;
  errorPremiosCastigosCheck = false;
  errorGeneral = false;

  constructor(
    private _util: UtilsService,
    private tipoOrdenesBalanzaS: TipoOrdenesBalanzaService
  ) {
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'id',
        sortable: true,
        filter: true,
        width: 60,
      },
      {
        headerName: 'Descripción',
        field: 'desca',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Tipo Orden',
        field: 'descTipOrden',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        },
      },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.agregarForm.get('id')?.disable({onlySelf: true});
    this.girdComponent();
    this.obtenerTipoOrdenBalanza();
  }

  obtenerTipoOrdenBalanza() {
    this.loading = true;
    this.tipoOrdenesBalanzaS.obtener().subscribe(
      (resp) => {
        let rowData = resp;
        rowData.forEach(item => {
          switch (item.tipOrden) {
            case 0:
              item.descTipOrden = "Compra";
              break;
            case 1:
              item.descTipOrden = "Venta";
              break;
            case 2:
              item.descTipOrden = "Traslado";
              break;
            case 3:
              item.descTipOrden = "Informativo";
              break;
            case 4:
              item.descTipOrden = "Maquila";
              break;
            default:
              item.descTipOrden = "";
              break;

              return item;
          }
        });
        this.rowData = rowData;
        this.loading = false;
        console.log("this.rowData", this.rowData)
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }

  guardarEditar() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    data.inspec = data.inspec == null || !data.inspec ? 0 : 1;
    data.ingresa = data.ingresa == null || !data.ingresa ? 0 : 1;
    data.reqOrden = data.reqOrden == null || !data.reqOrden ? 0 : 1;
    data.gradoApi = data.gradoApi == null || !data.gradoApi ? 0 : 1;
    data.oriFlete = data.oriFlete == null || !data.oriFlete ? 0 : 1;
    data.paramCalidad = data.paramCalidad == null || !data.paramCalidad ? 0 : 1;
    data.premiCastigo = data.premiCastigo == null || !data.premiCastigo ? 0 : 1;
    data.generaOcAuto = data.generaOcAuto == null || !data.generaOcAuto ? 0 : 1;
    data.prePesaje = data.prePesaje == null || !data.prePesaje ? 0 : 1;
    data.reCaptura = data.reCaptura == null || !data.reCaptura ? 0 : 1;
    // data.tipoBloqueo = data.tipoBloqueo == null || data.tipoBloqueo == "" ? "0" : data.tipoBloqueo

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        text: `Descripcion: ${data.desca}`,
        action: this.DAT_BTNS.editar,
        funcion: this.tipoOrdenesBalanzaS.actualizar(data),
      })
      .then(() => {
        this.obtenerTipoOrdenBalanza();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarCrearNueva() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();
    
    console.log("data1", data);

    data.inspec = data.inspec == null || !data.inspec ? 0 : 1;
    data.ingresa = data.ingresa == null || !data.ingresa ? 0 : 1;
    data.reqOrden = data.reqOrden == null || !data.reqOrden ? 0 : 1;
    data.gradoApi = data.gradoApi == null || !data.gradoApi ? 0 : 1;
    data.oriFlete = data.oriFlete == null || !data.oriFlete ? 0 : 1;
    data.paramCalidad = data.paramCalidad == null || !data.paramCalidad ? 0 : 1;
    data.premiCastigo = data.premiCastigo == null || !data.premiCastigo ? 0 : 1;
    data.generaOcAuto = data.generaOcAuto == null || !data.generaOcAuto ? 0 : 1;
    data.prePesaje = data.prePesaje == null || !data.prePesaje ? 0 : 1;
    data.reCaptura = data.reCaptura == null || !data.reCaptura ? 0 : 1;
    // data.tipoBloqueo = data.tipoBloqueo == null || data.tipoBloqueo == "" ? "0" : data.tipoBloqueo;

    console.log("data2", data)

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Descripcion: ${data.desca}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.tipoOrdenesBalanzaS.crear(data),
      })
      .then(() => {
        this.obtenerTipoOrdenBalanza();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarForm.reset();
    this.agregarForm.controls['granel'].setValue(0);
    this.openModal();
  }

  editar({rowData}) {
    console.log("rowData", rowData)
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.agregarForm.patchValue(rowData);
    this.agregarForm.get("tipoTolerancia").setValue(rowData.tipoTolerancia == "KILOS" ? 0 : rowData.tipoTolerancia == "PORCENTAJE" ? 1 : 2);
    this.openModal();
  }

  eliminar({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: `Descripcion: ${rowData.desca}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.tipoOrdenesBalanzaS.borrar(rowData.id),
      })
      .then((res: any) => {
        this.obtenerTipoOrdenBalanza();
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
    if (!this.isCreate) this.guardarEditar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  trimStringDesc() {
    let val = this.agregarForm.get('desca').value;
    this.agregarForm.controls['desca'].setValue(val.trimStart());
  }

  trimStringTole() {
    let val = this.agregarForm.get('tolerancia').value;
    this.agregarForm.controls['tolerancia'].setValue(val.trimStart());
  }

  trimString() {
    let val = this.agregarForm.get('clasePerdido').value;
    this.agregarForm.controls['clasePerdido'].setValue(val.trim());
    val = this.agregarForm.get('orgCompra').value;
    this.agregarForm.controls['orgCompra'].setValue(val.trim());
    val = this.agregarForm.get('grupoCompra').value;
    this.agregarForm.controls['grupoCompra'].setValue(val.trim());
  }

  validaciones() {
    //COMPRA
    if (this.agregarForm.get('tipOrden').value == 0) {

      console.log("premiCastigo", this.agregarForm.get('premiCastigo').value)
      console.log("paramCalidad", this.agregarForm.get('paramCalidad').value)

      if (this.agregarForm.get('reqOrden').value && this.agregarForm.get('generaOcAuto').value) {
        this.errorBothOrderCheck = true;
      } else {
        this.errorBothOrderCheck = false;
      }

      if (this.agregarForm.get('premiCastigo').value && !this.agregarForm.get('paramCalidad').value) {
        this.errorPremiosCastigosCheck = true;
      } else {
        this.errorPremiosCastigosCheck = false;
      }

      if (this.agregarForm.get('inspec').value && !this.agregarForm.get('paramCalidad').value) {
        this.errorLoteInspeccionCheck = true;
      } else {
        this.errorLoteInspeccionCheck = false;
      }

      if (this.agregarForm.get('generaOcAuto').value == true) {
        this.agregarForm.get('clasePerdido').setValidators([Validators.required]);
        this.agregarForm.get('orgCompra').setValidators([Validators.required]);
        this.agregarForm.get('grupoCompra').setValidators([Validators.required]);
      } else {
        this.agregarForm.get('clasePerdido').setValidators([]);
        this.agregarForm.get('orgCompra').setValidators([]);
        this.agregarForm.get('grupoCompra').setValidators([]);
      }

      this.agregarForm.get('granel').setValidators([]);
      this.agregarForm.get('tolerancia').setValidators([]);

      this.agregarForm.get('granel').updateValueAndValidity();
      this.agregarForm.get('tolerancia').updateValueAndValidity();
      this.agregarForm.get('clasePerdido').updateValueAndValidity();
      this.agregarForm.get('orgCompra').updateValueAndValidity();
      this.agregarForm.get('grupoCompra').updateValueAndValidity();

    }
    //DIFERENTE A COMPRA
    else {
      this.agregarForm.get('granel').setValidators([Validators.required]);
      this.agregarForm.get('tolerancia').setValidators([Validators.required]);
      this.agregarForm.get('granel').updateValueAndValidity();
      this.agregarForm.get('tolerancia').updateValueAndValidity();
    }

    // VENTA O TRASLADOS
    if(this.agregarForm.get('tipOrden').value == 1 || this.agregarForm.get('tipOrden').value == 2){
      this.agregarForm.get('prePesaje').setValidators([Validators.required]);
    }

    if (this.errorBothOrderCheck || this.errorPremiosCastigosCheck || this.errorLoteInspeccionCheck) this.errorGeneral = true;
    else this.errorGeneral = false;

    console.log("errorGeneral", this.errorGeneral)
    console.log("agregarForm.invalid ", this.agregarForm.invalid)

  }

}
